/* eslint-disable array-callback-return */
import moment from 'moment';
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { BsFiletypeXlsx } from 'react-icons/bs';

import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useServerProduct from '../../../api/useServerProducts';
import Input from '../../../components/forms/Input';
import MovementsTypeBadge from '../../../components/misc/badges/MovementsTypeBadge';
import StockCategoryTypeBadge from '../../../components/misc/badges/StockCategoryTypeBadge';
import Button from '../../../components/misc/Button';
import GenericTable, {
    DataTableInterface, FilterOpts
} from '../../../components/misc/GenericTable';
import { BtnActions } from '../../../components/misc/MultipleActBtn';
import Paginate from '../../../components/misc/Paginate';
import Modal from '../../../components/modals/GenericModal';
import { BasicType, SelectInterface } from '../../../interfaces/InterfacesLocal';
import { Movement } from '../../../interfaces/ServerInterfaces';
import { useAppSelector } from '../../../store/hooks';
import { exportExcel } from '../../../utils/helpers';
import {
    translateDispatchStatus, translateMeasure, translateMovementCategory, translateOperation
} from '../../../utils/translate';
import DetailMovement from '../../areas/stock/movements/DetailMovement';
import { DetailProductContext } from '../DetailProductContainer';

const Opperations = () => {
  const { product } = useContext(DetailProductContext)
  const { areas } = useAppSelector((state) => state.nomenclator)
  const { getOperations, allOperations, paginate, isLoading } =
    useServerProduct()
  const defaultFilter = { productId: product?.id ?? null, page: 1 }
  const [filter, setFilter] =
    useState<Record<string, string | number | boolean | null>>(defaultFilter)
  const [modalMovement, setModalMovement] = useState<{
    movementId: number | null
    modalState: boolean
  }>({ movementId: null, modalState: false })

  const [exportModal, setExportModal] = useState(false)

  useEffect(() => {
    getOperations(filter)
  }, [filter])

  //Data for filters -----------------------------------------------------------------------------------
  const typesDisplay: SelectInterface[] = []
  const types: string[] = [
    'ENTRY',
    'MOVEMENT',
    'OUT',
    'TRANSFORMATION',
    'SALE',
    'WASTE',
    'TRANSFORMATION',
  ]
  types.forEach((item) =>
    typesDisplay.push({ id: item, name: translateOperation(item) })
  )

  //------------------------------------------------------------------------------------

  //Data for GenericTable -----------------------------------------------------------------
  const tableTitles = ['Operación', 'Categoría', 'Cantidad', 'Fecha', 'Usuario']
  if (product?.type === 'VARIATION') tableTitles.unshift('Variación')
  const tableData: DataTableInterface[] = []
  allOperations.map((movement) => {
    if (product?.type === 'VARIATION') {
      tableData.push({
        rowId: movement.id,
        deletedRow: movement.removedOperationId !== null,
        payload: {
          Variación: movement.variation?.name,
          Operación: <MovementsTypeBadge operation={movement.operation} />,
          Categoría: !!movement.category ? (
            <StockCategoryTypeBadge category={movement.category} />
          ) : (
            '-'
          ),
          Cantidad: `${movement.quantity} ${translateMeasure(
            movement.product.measure
          )}`,
          Fecha: `${moment(movement.createdAt).format('DD/MM/YYYY hh:mm A')}`,
          Usuario: movement.movedBy ? (
            movement.movedBy.displayName
          ) : (
            <FontAwesomeIcon
              icon={faMinusCircle}
              className="h-4 text-gray-400"
            />
          ),
        },
      })
    } else {
      tableData.push({
        rowId: movement.id,
        deletedRow: movement.removedOperationId !== null,
        payload: {
          Operación: <MovementsTypeBadge operation={movement.operation} />,
          Categoría: !!movement.category ? (
            <StockCategoryTypeBadge category={movement.category} />
          ) : (
            '-'
          ),
          Cantidad: `${movement.quantity} ${translateMeasure(
            movement.product.measure
          )}`,
          Fecha: `${moment(movement.createdAt).format('DD/MM/YYYY hh:mm A')}`,
          Usuario: movement.movedBy ? (
            movement.movedBy.displayName
          ) : (
            <FontAwesomeIcon
              icon={faMinusCircle}
              className="h-4 text-gray-400"
            />
          ),
        },
      })
    }
  })

  const availableFilters: FilterOpts[] = [
    {
      name: 'Operación',
      filterCode: 'operation',
      format: 'select',
      data: typesDisplay,
    },
    {
      format: 'multiselect',
      filterCode: 'category',
      name: 'Categoría',
      data: [
        { name: 'Traslado', id: 'TRASLATE' },
        { name: 'Venta', id: 'SALE' },
        { name: 'Compra', id: 'BUY' },
        { name: 'Ajuste', id: 'ADJUST' },
        { name: 'Procesado', id: 'PROCESSED' },
        { name: 'Descomposición', id: 'DESCOMPOSITION' },
        { name: 'Elaboración', id: 'ELABORATION' },
        { name: 'Despacho', id: 'DISPATCH' },
        { name: 'Contenedor', id: 'CONTAINER' },
        { name: 'Salida', id: 'OUT' },
        { name: 'Desperdicio', id: 'WASTE' },
        { name: 'Transformación', id: 'TRANSFORMATION' },

        // { name: "Extracción", id: "EXTRACTION" },
        // { name: "Entrada rápida", id: "FAST_ENTRY" },
        // { name: "Reembolsado", id: "REFUNDED" },
      ],
    },
    {
      name: 'Área',
      filterCode: 'areaId',
      format: 'select',
      data: areas
        .filter((item) => item.type === 'STOCK')
        .map((elem) => ({ id: elem.id, name: elem.name })),
    },
    {
      filterCode: 'dateRange',
      name: 'Rango de fechas',
      format: 'datepicker-range',
      isUntilToday: true,
      datepickerRange: [
        {
          filterCode: 'dateFrom',
          name: 'Desde',
          isUnitlToday: true,
        },
        {
          filterCode: 'dateTo',
          name: 'Hasta',
          isUnitlToday: true,
        },
      ],
    },
  ]

  const filterAction = (data: BasicType | null) => {
    data ? setFilter({ ...defaultFilter, ...data }) : setFilter(defaultFilter)
  }

  const actions: BtnActions[] = [
    {
      title: 'Exportar a excel',
      action: () => setExportModal(true),
      icon: <BsFiletypeXlsx />,
    },
  ]

  //-------------------------------------------------------------------------------------

  return (
    <div className="h-[34rem] overflow-auto rounded-md border border-slate-300 p-5 px-5 pb-16 scrollbar-none">
      <GenericTable
        tableTitles={tableTitles}
        tableData={tableData}
        paginateComponent={
          <Paginate
            action={(page: number) => setFilter({ ...filter, page })}
            data={paginate}
          />
        }
        rowAction={(id: number) => {
          setModalMovement({ modalState: true, movementId: id })
        }}
        filterComponent={{ availableFilters, filterAction }}
        loading={isLoading}
        actions={actions}
      />

      {modalMovement.modalState && (
        <Modal
          close={() =>
            setModalMovement({
              modalState: false,
              movementId: null,
            })
          }
          state={modalMovement.modalState}
          size="l"
        >
          <DetailMovement id={modalMovement.movementId} />
        </Modal>
      )}

      {exportModal && (
        <Modal state={exportModal} close={setExportModal}>
          <ExcelFileExport
            closeModal={() => setExportModal(false)}
            allOperations={allOperations}
          />
        </Modal>
      )}
    </div>
  )
}

interface ExportContainer {
  closeModal: Function
  allOperations: Movement[]
}
const ExcelFileExport = ({ closeModal, allOperations }: ExportContainer) => {
  const { handleSubmit, control } = useForm()

  const onSubmit: SubmitHandler<Record<string, string>> = (data) => {
    const dataToExport: Record<string, string | number>[] = []
    allOperations.map((item) =>
      dataToExport.push({
        Operación: translateOperation(item.operation),
        Categoría: translateMovementCategory(item.category ?? ''),
        //@ts-ignore
        Estado: translateDispatchStatus(item?.status),
        Producto: item?.product?.name,
        Cantidad: item.quantity,
        Fecha: moment(item.createdAt).format('DD/MM/YYYY hh:mm A'),
        Usuario: item.movedBy ? item.movedBy.displayName : '',
        Área: item.area.name,
        Descripción: item.description,
      })
    )
    exportExcel(dataToExport, data.name)
    closeModal()
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input
        name="name"
        label="Nombre del archivo"
        placeholder="Nombre del archivo .xlsx"
        control={control}
        rules={{ required: 'Debe indicar un nombre para el archivo' }}
      />
      <div className="flex justify-end py-2">
        <Button type="submit" name="Exportar" color="slate-600" />
      </div>
    </form>
  )
}

export default Opperations
